<!--  -->
<template>
  <div>
    <div class="sort-content">
      <div class="sort-search">
        <div class="sales-scope" :class="'sales-scope-active'">
          <div class="txt">
            <span>销售范围</span>
            <div class="rule-content">
              <el-tooltip class="item" placement="right">
                <div slot="content">
                  全平台销售：指商品对平台所有采购用户销售，包括协议客户。
                  <br />
                  协议客户销售：指商品只对协议客户以协议价销售，不对协议客户以外的用户销售。如需对全平台销售，请先向申请商品可售类目。
                </div>
                <span class="tip-icon">?</span>
              </el-tooltip>
            </div>
          </div>

          <div class="btn-radio-wrap" @click="handleSalesScope(1)">
            <div
              class="circle-wrap"
              :class="salesScope === 1 ? 'circle-wrap-active' : ''"
            ></div>
            <div
              class="btn-wrap"
              :class="salesScope === 1 ? 'btn-wrap-active' : ''"
            >
              <eui-icon icon="eicon-r-l-quanbu" font-size="20px"></eui-icon>
              <span>向全平台客户销售</span>
            </div>
          </div>
          <div class="btn-radio-wrap" @click="handleSalesScope(2)">
            <div
              class="circle-wrap"
              :class="salesScope === 2 ? 'circle-wrap-active' : ''"
            ></div>
            <div
              class="btn-wrap"
              :class="salesScope === 2 ? 'btn-wrap-active' : ''"
            >
              <eui-icon icon="eicon-r-l-xieyi" font-size="20px"></eui-icon>
              <span>向协议客户销售</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sort-content margin-top-20">
      <div class="sort-search">
        <div class="sales-scope product-type" :class="'sales-scope-active'">
          <div class="txt">
            <span>商品类别</span>
            <div class="rule-content">
              <el-tooltip class="item" placement="right">
                <div slot="content">
                  标准商品：标准商品指具有统一规格、质量标准和明确交易规则的商品
                  <br />
                  非标商品：无法完全满足标准化要求的定制化产品或特殊规格商品
                </div>
                <span class="tip-icon">?</span>
              </el-tooltip>
            </div>
          </div>

          <div class="btn-radio-wrap" @click="handleSalesType(1)">
            <div
              class="circle-wrap"
              :class="salesType === 1 ? 'circle-wrap-active' : ''"
            ></div>
            <div
              class="btn-wrap"
              :class="salesType === 1 ? 'btn-wrap-active' : ''"
            >
              <eui-icon
                icon="eicon-r-l-changcaiwuzi"
                font-size="20px"
              ></eui-icon>
              <span>标准商品发布</span>
            </div>
          </div>
          <div
            class="btn-radio-wrap"
            @click="handleSalesType(2)"
            v-if="salesScope !== 2"
          >
            <div
              class="circle-wrap"
              :class="salesType === 2 ? 'circle-wrap-active' : ''"
            ></div>
            <div
              class="btn-wrap"
              :class="salesType === 2 ? 'btn-wrap-active' : ''"
            >
              <eui-icon icon="eicon-r-lijidingzhi" font-size="20px"></eui-icon>
              <span>非标准商品发布</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    salesScope: {
      type: Number,
      default: 1,
    },
    salesType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      imgList: {
        platformChoice: require('../../../../../assets/img/product/icon-platform-choice.png'),
        platformDefault: require('../../../../../assets/img/product/icon-platform-default.png'),
        agreementChoice: require('../../../../../assets/img/product/icon-agreement-choice.png'),
        agreementDefault: require('../../../../../assets/img/product/icon-agreement-default.png'),
        searchDefault: require('../../../../../assets/img/product/icon-search-default.png'),
      },
    };
  },

  components: {},

  computed: {},

  created() {},
  methods: {
    handleSalesScope(val) {
      this.$emit('handleSalesScope', val);
    },
    handleSalesType(val) {
      this.$emit('handleSalesType', val);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../../assets/css/theme.scss';
// .isActive::v-deep .el-input__inner {
//   border-left: 1px solid $main-col;
//   border-top: 1px solid $main-col;
// }
.sort-content {
  // padding: 0 30px;
  margin: 20px 0;
  .sort-search {
    display: flex;
    flex-flow: column;
    // align-items: center;
    // margin-bottom: 20px;
    > p {
      color: #000;
      font-size: 16px;
    }
  }
}
.sales-scope {
  display: flex;
  align-items: center;
  .txt {
    display: flex;
    align-items: center;
    margin-right: 20px;
    > span {
      color: #333;
      font-size: 16px;
    }
    .rule-content {
      font-size: 0;
    }
  }
  //  ::v-deep  .el-radio__label {
  //   border: 1px solid #000;
  //     padding: 10px 20px 10px 20px;
  //     margin-left: 13px;
  // }
  .tip-icon {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    color: #c5c5c5;
    font-size: 12px;
    cursor: pointer;
    margin-left: 16px;
    &:hover {
      border: 1px solid #d9d9d9;
      color: #fff;
      background: #d9d9d9;
    }
  }
}
.sales-scope ::v-deep .el-radio__label {
  border: 1px solid #d9d9d9;
  padding: 10px 20px 10px 50px;
  margin-left: 13px;
  position: relative;
  // width: 190px;
  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
}

.sales-scope ::v-deep .is-checked .el-radio__label {
  border: 1px solid $main-col;
}
.margin-wrap {
  margin-right: 34px;
}
.margin-top-20 {
  margin-top: 40px;
}
.btn-radio-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 40px;
  cursor: pointer;
  .circle-wrap {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    margin-right: 10px;
  }
  .circle-wrap-active {
    width: 18px;
    height: 18px;
    background-color: #fff;
    border-radius: 50%;
    border: 6px solid $main-col;
    margin-right: 10px;
  }
  .btn-wrap {
    border: 1px solid #d9d9d9;
    width: 162px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #333;
    span {
      margin-left: 10px;
    }
  }
  .btn-wrap-active {
    border: 1px solid $main-col;
    color: $main-col;
  }
}
</style>
